import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './styles.scss'
import { useLazyLoad } from '_hooks'

const COLORS = [
  '#13682b', // $ds_green
  '#ecf3ee', // $ds_green_five
]

const ProgressChart = ({ className, percentage }) => {
  const roundedPercentage = Math.trunc(percentage * 100)

  const chartData = [
    {
      name: 'Current percentage',
      value: roundedPercentage,
    },
    {
      name: 'Total minus current percentage',
      value: 100 - roundedPercentage,
    },
  ]

  const [{ PieChart, Pie, Cell }, loadingRecharts] = useLazyLoad(import('recharts'))

  return (
    <div className={classnames('progress-chart', className)}>
      <div className="progress-chart__chart">
        <If condition={!loadingRecharts}>
          <PieChart width={80} height={80}>
            <Pie
              data={chartData}
              cx={35}
              cy={35}
              innerRadius={35}
              outerRadius={40}
              paddingAngle={0}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </If>
      </div>
      <span className="progress-chart__percentage">{roundedPercentage}%</span>
    </div>
  )
}

ProgressChart.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number,
}

ProgressChart.defaultProps = {
  className: '',
  percentage: 0,
}

export default React.memo(ProgressChart)
